import styled from 'styled-components';
import {
  Body,
  H1,
  H3,
  CircledNumber as DefaultCircledNumber,
} from 'components/Typography';
import DefaultIndicator from 'components/Indicator';
import DefaultPieChart from 'components/Charts/PieChart';
import addAlpha from 'utils/addAlpha';
import DefaultAreaChart from 'components/Charts/AreaChart';
import DefaultDatesSelector from 'components/Form/WeekRangePicker';

// TODO: TFR-44 move to container group or do not export
export const Container = styled.div`
  width: 100%;
  height: auto;
  padding: 0;
  margin-bottom: 8rem;
`;

// TODO: TFR-45:Title make unique name or do not export
export const Title = styled(H1)`
  font-weight: 700;
  margin-bottom: 1rem;
`;

// TODO: TFR-45:Header make unique name or do not export
export const Header = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1.5rem;
`;

// TODO: TFR-45:Date make unique name or do not export
export const DateCaption = styled(H3)`
  margin-right: 1.5rem;
`;

// TODO: TFR-46 remove imports in styled.ts if you do not add styles to component
export const DatesSelector = styled(DefaultDatesSelector)``;

// TODO: TFR-44 move to typography group
export const SectionTitle = styled(H3)`
  margin-bottom: 1rem;
`;

// TODO: TFR-44 move to container group
export const Indicators = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(15rem, 1fr));
  gap: 2rem;
  margin-bottom: 2rem;
`;

// TODO: TFR-44 move to container group
export const TwoColumns = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 2rem;
  margin-bottom: 1.875rem;
`;

// TODO: TFR-44 move to container group
export const Fragment = styled.div`
  width: 100%;
  height: 41.7rem;
`;

// TODO: TFR-44 move to container group
export const Section = styled.div``;

// TODO: TFR-46 remove imports in styled.ts if you do not add styles to component
export const Indicator = styled(DefaultIndicator)``;

// TODO: TFR-49 split components into two or more different logical components
export const RatingsCard = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  width: 100%;
  border-radius: 1rem;
  padding: 2.1875rem 2rem;
`;
// TODO: TFR-44 move to container group
export const ChartWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  width: 36.25rem;
  border-radius: 1rem;
  padding: 2.125rem 2rem;
`;

// TODO: TFR-46 remove imports in styled.ts if you do not add styles to component
export const PieChart = styled(DefaultPieChart)``;

// TODO: TFR-49 split components into two or more different logical components
export const Item = styled.div`
  display: flex;
  :not(:last-child) {
    margin-bottom: 1.3125rem;
  }
`;

// TODO: TFR-45:Name make unique name or do not export
export const Name = styled(Body)`
  font-weight: 600;
`;

// TODO: TFR-44 move to typography group
export const Number = styled(Body)`
  color: ${({ theme }) => addAlpha(theme.colors.navyGreen, 0.8)};
  font-variant-numeric: tabular-nums;
  margin-left: auto;
  margin-right: 0px;
`;

// TODO: TFR-46 remove imports in styled.ts if you do not add styles to component
export const CircledNumber = styled(DefaultCircledNumber)``;

export const Top5Item = styled(Item)`
  justify-content: space-between;
  ${Name} {
    margin-left: 0.75rem;
  }
`;

export const RankingItem = styled(Item)`
  justify-content: space-between;
`;

// TODO: TFR-46 remove imports in styled.ts if you do not add styles to component
export const AreaChart = styled(DefaultAreaChart)``;
